<template>
  <div>
    <v-menu
      v-model="menu1"
      :close-on-content-click="false"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      max-width="225px"
      min-width="225px"
    >
      <template #activator="{ on }">
        <v-text-field v-model="colorHex" v-bind="$attrs" v-on="on" @focus="on">
          <template #prepend-inner>
            <v-icon :color="colorHex"> fa-paint-brush </v-icon>
          </template>
        </v-text-field>
      </template>
      <chrome v-model="color" @input="debounceInput" />
    </v-menu>
  </div>
</template>

<script>
import { debounce } from 'debounce'
import { Chrome } from 'vue-color'
export default {
  name: 'ColorPicker',
  components: { Chrome },
  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      menu1: false,
      colorHex: '',
      color: { hex: '' },
    }
  },
  watch: {
    value(val) {
      this.colorHex = val
    },
    colorHex(val) {
      if (val && val !== this.color.hex) {
        this.color = { hex: val }
      }
    },
  },
  methods: {
    debounceInput: debounce(function (value) {
      let color = value
      if (typeof color === 'object') color = value.hex
      this.$emit('input', color)
    }, 200),
  },
}
</script>
